










import {Component, Vue} from 'vue-property-decorator';
import ProductsTable from '@/screens/dashboard/products/ProductsTable.vue';

@Component({
  components: { ProductsTable }
})
export default class ProductScreen extends Vue {
}
